import React, { lazy } from 'react';
import AppConfig from './appConfig';
 
const Login = lazy(() => import('../pages/login/Login'));
const Logout = lazy(() => import('../pages/logout/Logout'));
const Home = lazy(() => import('../pages/home/Home'));
const Details = lazy(() => import('../pages/detail/Detail'));
const Glossary = lazy(() => import('../pages/glossary/Glossary'));
const WhatsNew = lazy(() => import('../pages/whatsNew/WhatsNew'));
const NewJoiner = lazy(() => import('../pages/newJoiner/NewJoiner'));
const Result = lazy(() => import('../pages/result/Result'));
const Compare = lazy(() => import('../pages/compare/Compare'));
const RecentlyViewed = lazy(() => import('../pages/myDataViewAll/MyDataViewAll'));
const MyDataViewAll = lazy(() => import('../pages/myDataViewAll/MyDataViewAll'));
const DataProduct = lazy(() => import('../pages/dataProduct/DataProduct'));
const Requests = lazy(() => import('../pages/requests/Requests'));
const ClientDetails = lazy(() => import('../pages/clientDetail/ClientDetail'));
const Dashboard = lazy(() => import('../pages/dashboard/Dashboard'));
const RegisterDataProduct = lazy(() => import('../pages/registerDataProduct/RegisterDataProduct'));

const AppRoutes = [
  { path: '/', element: <Home />, private: true },
  { path: AppConfig.routePaths.login, element: <Login /> },
  { path: AppConfig.routePaths.logout, element: <Logout /> },
  { path: AppConfig.routePaths.home, element: <Home />, private: true },
  { path: AppConfig.routePaths.details, element: <Details />, private: true },
  { path: AppConfig.routePaths.glossary, element: <Glossary />, private: true },
  { path: AppConfig.routePaths.whatsNew, element: <WhatsNew />, private: true },
  { path: AppConfig.routePaths.newJoiner, element: <NewJoiner />, private: true },
  { path: AppConfig.routePaths.results, element: <Result />, private: true },
  { path: AppConfig.routePaths.compare, element: <Compare />, private: true },
  { path: AppConfig.routePaths.recentlyViewAll, element: <RecentlyViewed />, private: true },
  { path: AppConfig.routePaths.myDataViewAll, element: <MyDataViewAll />, private: true },
  { path: AppConfig.routePaths.dataProduct, element: <DataProduct />, private: true },
  { path: AppConfig.routePaths.requests, element: <Requests />, private: true },
  { path: AppConfig.routePaths.clientdetails, element: <ClientDetails />, private: true },
  { path: AppConfig.routePaths.dashboard, element: <Dashboard />, private: true },
  { path: AppConfig.routePaths.registerDataProduct, element: <RegisterDataProduct />, private: true },
];
export default AppRoutes;